import { useState } from "react";
import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { LoadingButton } from "@mui/lab";
import { socket } from "../../botSocket";

const SessionExpiredModal = ({
    sessionExpiredOpen,
    setSessionExpiredOpen,
    sessionExpiredPayload,
    setSessionExpiredPayload,
}) => {
    const [reLoginLoading, setReLoginLoading] = useState(false);

    const respond = (approved) => {
        const requestId = sessionExpiredPayload?.requestId;
        if (socket && requestId) {
            socket.emit("session-expired-response", {
                requestId,
                approved,
            });
        }
    };

    const handleClose = () => {
        respond(false);
        setSessionExpiredOpen(false);
        setSessionExpiredPayload(null);
    };

    const handleReLogin = async () => {
        setReLoginLoading(true);
        try {
            respond(true);
            setSessionExpiredOpen(false);
            setSessionExpiredPayload(null);
        } finally {
            setReLoginLoading(false);
        }
    };

    return (
        <Dialog open={sessionExpiredOpen} onClose={handleClose}>
            <Box className="sessionExpiredModal">
                <DialogTitle className="sessionExpiredModalTitle">
                    <InfoOutlinedIcon
                        className="sessionExpiredModalTitleIcon"
                        color="secondary"
                    />
                    Session Expired
                </DialogTitle>
                <DialogContent className="sessionExpiredModalContent">
                    <Typography
                        className="sessionExpiredModalText"
                        variant="body1"
                    >
                        Your authorization session for this project has expired.
                        <br />
                        To continue the current task, confirm re-login and enter
                        a fresh OTP code when prompted.
                    </Typography>
                </DialogContent>
                <DialogActions className="sessionExpiredModalActions">
                    <Button
                        className="sessionExpiredModalButton"
                        onClick={handleClose}
                        color="secondary"
                        variant="outlined"
                    >
                        CANCEL
                    </Button>
                    {reLoginLoading ? (
                        <LoadingButton
                            loading
                            className="sessionExpiredModalButton"
                            variant="contained"
                            loadingIndicator={
                                <CircularProgress color="white" size={16} />
                            }
                        />
                    ) : (
                        <Button
                            className="sessionExpiredModalButton"
                            onClick={handleReLogin}
                            color="secondary"
                            variant="contained"
                        >
                            RE-LOGIN
                        </Button>
                    )}
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default SessionExpiredModal;
